// @flow
import React from 'react';
import { render } from 'react-dom';
import { AppContainer } from 'react-hot-loader';

import fetch from 'utils/fetch';
import createStore from './store';
import Root from './components/Root';

const store = createStore();

const mountApp = () => {
  render(
    <AppContainer>
      <Root store={store} />
    </AppContainer>,
    document.getElementById('root')
  );
};

const getFeaturesUrl = () => {
  if (process.env.FE_NODE_ENV === 'development') {
    return '/api/v1/features/';
  }

  return `https://${process.env.FE_HOSTING_DOMAIN}/api/v1/features/`;
};

const renderRoot = () => {
  const hadToken = !!localStorage.getItem('token');

  fetch(getFeaturesUrl())
    .then(response => response.json())
    .then(features => {
      localStorage.setItem('features', JSON.stringify(features));
      mountApp();
    })
    .catch(() => {
      if (hadToken && !localStorage.getItem('token')) {
        return;
      }

      localStorage.setItem('features', JSON.stringify({}));
      mountApp();
    });
};
renderRoot();

if (module.hot) {
  module.hot.accept('./components/Root', renderRoot);
}



// WEBPACK FOOTER //
// ./index.js